import { AuditTrailItem } from '@wilson/api/gateway';

export class ResetAuditTrailShiftState {
  static readonly type = '[AuditTrailShift] ResetAuditTrailShiftState';
}

export class UpsertAuditTrailShiftState {
  static readonly type = '[AuditTrailShift] UpsertAuditTrailShiftState';
  constructor(
    public shiftId: string,
    public auditTrailShift: AuditTrailItem[],
  ) {}
}
